import { useMutation, useQueryClient } from 'react-query';

import { PostReport } from '../../../types/PostReport';
import Api from '../../api/api';

export const reinstateReportedPost = async (reportPostId: string) => {
  const [response, bodyOrError] = await Api.patch(`posts/${reportPostId}/reinstate-reported-post`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useReinstateReportedPost = () => {
  const queryClient = useQueryClient();

  return useMutation<PostReport, Error, string>('reinstateReportedPost', reinstateReportedPost, {
    onSuccess: () => {
      queryClient.invalidateQueries('reportedPosts');
    },
  });
};
